import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    allowEmptyOption: Boolean,
    removeButtonConfirmMessage: String,
    tagColours: String,
    withRemoveButton: Boolean,
    withTags: Boolean,
  };

  connect() {
    if (this.withTagsValue) {
      this.boundTagItemRender = this.tagItemRender.bind(this);
    }

    this.initializeTomSelect();
  }

  disconnect() {
    if (this.scrollParent && this.onScroll) {
      this.scrollParent.removeEventListener("scroll", this.onScroll);
    }
    this.destroyTomSelect();
  }

  initializeTomSelect() {
    let config = {
      maxOptions: null,
      searchConjunction: "or",
      allowEmptyOption: this.allowEmptyOptionValue,
      hidePlaceholder: true,
      dropdownParent: "body",
      onChange: function () {
        // shows placeholder if null value is selected
        !this.getValue() && this.clear(true);
      },
    };

    if (this.withRemoveButtonValue) {
      config = {
        ...config,
        plugins: {
          remove_button: { title: "remove" },
        },
      };
    }

    if (this.removeButtonConfirmMessageValue) {
      config = {
        ...config,
        onDelete: ([option_id, asdf]) => {
          return confirm(this.removeButtonConfirmMessageValue);
        },
      };
    }

    if (this.withTagsValue) {
      const self = this; // needed to add scope into the config[:render]
      config = {
        ...config,
        render: {
          item: this.boundTagItemRender,
        },
      };
    }

    new TomSelect(this.element, config);

    // dropdownParent: "body" detaches the dropdown from the control, so it won't follow on scroll.
    // Close it on scroll to match native <select> behaviour.
    this.scrollParent = this.element.closest(".modal-body") || window;
    this.onScroll = () => this.element.tomselect.close();
    this.scrollParent.addEventListener("scroll", this.onScroll, { passive: true });
  }

  destroyTomSelect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy();
    }
  }

  tagItemRender(data, escape) {
    let color = this.getColorForUUID(data.value);
    return (
      `<div class="badge rounded-pill p-2 my-1 text-wrap" style="background-color: #${color}; color: #FAFAFA">` +
      escape(data.text) +
      `</div>`
    );
  }

  // Assigns a colour from the array of colours according to the item's UUID; ensures it is the same colour every time
  getColorForUUID(uuid) {
    let hash = 0;
    for (let i = 0; i < uuid.length; i++) {
      hash += uuid.charCodeAt(i);
    }
    const colours = JSON.parse(this.tagColoursValue);
    return colours[Math.abs(hash) % colours.length];
  }
}
